/**
 * Enum of all feature flag names.
 */
export enum FeatureFlag {
  AccessArchive = 'accessArchive',
  AgentChat = 'agentChat',
  BusinessPartnerSettings = 'businessPartnerSettings',
  ClientPortal = 'clientPortal',
  ConcreteDiary = 'concreteDiary',
  CreateDeliveryNote = 'createDeliveryNote',
  CreateDemoDlns = 'createDemoDlns',
  CustomerSubscription = 'customerSubscription',
  DataSyncUi = 'dataSyncUi',
  DeactivatedCompanyAccount = 'deactivatedCompanyAccount',
  DisableGps = 'disableGps',
  DisableInvoices = 'disableInvoices',
  DlnListV2 = 'dlnListV2',
  EnableFastScan = 'enableFastScan',
  EnableValidatedScan = 'enableValidatedScan',
  EsgAnalytics = 'esgAnalytics',
  EsgMaterialMatcher = 'esgMaterialMatcher',
  Flixbeton = 'flixbeton',
  InvoiceListV2 = 'invoiceListV2',
  LoadDlnsAmount = 'loadDlnsAmount',
  ManageProductPrices = 'manageProductPrices',
  ManualInvoiceCheckingPipeline = 'manualInvoiceCheckingPipeline',
  ModuleCallOffs = 'moduleCallOffs',
  ModuleContracts = 'moduleContracts',
  ModuleInvoiceRestriction = 'moduleInvoiceRestriction',
  NoPrivacyStatement = 'noPrivacyStatement',
  PackageBasicRestriction = 'packageBasicRestriction',
  PgDlnAnalytics = 'pgDlnAnalytics',
  PgDlnAttachments = 'pgDlnAttachments',
  PgDlnBulk = 'pgDlnBulk',
  PgDlnChains = 'pgDlnChains',
  PgDlnDetail = 'pgDlnDetail',
  PgDlnList = 'pgDlnList',
  PgDlnSearch = 'pgDlnSearch',
  PgDlnTransformed = 'pgDlnTransformed',
  PgDlnVadmin = 'pgDlnVadmin',
  ProductAnalyticsTools = 'productAnalyticsTools',
  ReleaseSyncedData = 'releaseSyncedData',
  SentryGoogleAnalyticsDisabled = 'sentryGoogleAnalyticsDisabled',
  ServiceNotes = 'serviceNotes',
  SupplierOverview = 'supplierOverview',
  SupplierOverviewForceCsRouting = 'supplierOverviewForceCsRouting',
  SupplierOverviewRequestSupplier = 'supplierOverviewRequestSupplier',
  SuppliersKanban = 'suppliersKanban',
  UserInDlnHistory = 'userInDlnHistory',
}

export type FeatureFlags = {
  [FeatureFlag.AccessArchive]: boolean;
  [FeatureFlag.AgentChat]: boolean;
  [FeatureFlag.BusinessPartnerSettings]: boolean;
  [FeatureFlag.ClientPortal]: boolean;
  [FeatureFlag.ConcreteDiary]: boolean;
  [FeatureFlag.CreateDeliveryNote]: boolean;
  [FeatureFlag.CreateDemoDlns]: boolean;
  [FeatureFlag.CustomerSubscription]: boolean;
  [FeatureFlag.DataSyncUi]: boolean;
  [FeatureFlag.DeactivatedCompanyAccount]: boolean;
  [FeatureFlag.DisableGps]: boolean;
  [FeatureFlag.DisableInvoices]: boolean;
  [FeatureFlag.DlnListV2]: boolean;
  [FeatureFlag.EnableFastScan]: boolean;
  [FeatureFlag.EnableValidatedScan]: boolean;
  [FeatureFlag.EsgAnalytics]: boolean;
  [FeatureFlag.EsgMaterialMatcher]: boolean;
  [FeatureFlag.Flixbeton]: boolean;
  [FeatureFlag.InvoiceListV2]: boolean;
  [FeatureFlag.LoadDlnsAmount]: number;
  [FeatureFlag.ManageProductPrices]: boolean;
  [FeatureFlag.ManualInvoiceCheckingPipeline]: boolean;
  [FeatureFlag.ModuleCallOffs]: boolean;
  [FeatureFlag.ModuleContracts]: boolean;
  [FeatureFlag.ModuleInvoiceRestriction]: boolean;
  [FeatureFlag.NoPrivacyStatement]: boolean;
  [FeatureFlag.PackageBasicRestriction]: boolean;
  [FeatureFlag.PgDlnAnalytics]: boolean;
  [FeatureFlag.PgDlnAttachments]: boolean;
  [FeatureFlag.PgDlnBulk]: boolean;
  [FeatureFlag.PgDlnChains]: boolean;
  [FeatureFlag.PgDlnDetail]: boolean;
  [FeatureFlag.PgDlnList]: boolean;
  [FeatureFlag.PgDlnSearch]: boolean;
  [FeatureFlag.PgDlnTransformed]: boolean;
  [FeatureFlag.PgDlnVadmin]: boolean;
  [FeatureFlag.ProductAnalyticsTools]: boolean;
  [FeatureFlag.ReleaseSyncedData]: boolean;
  [FeatureFlag.SentryGoogleAnalyticsDisabled]: boolean;
  [FeatureFlag.ServiceNotes]: boolean;
  [FeatureFlag.SupplierOverviewForceCsRouting]: boolean;
  [FeatureFlag.SupplierOverviewRequestSupplier]: boolean;
  [FeatureFlag.SuppliersKanban]: boolean;
  [FeatureFlag.UserInDlnHistory]: boolean;
};
